import * as React from "react";
import { connect } from "react-redux";
import { Button, Divider, Form, Modal } from "semantic-ui-react";

import { Input } from "@neworbit/simpleui-input";

import { IsLoadingButton } from "@teamprevent/common/IsLoadingButton";
import { TaskModel } from "@teamprevent/common/task/taskActions/models";

import { rebookingReasonsOptions, TaskActionProps } from "../model";
import { rebookAppointment } from "../../bookAppointments/actions";
import { REBOOK_APPOINTMENT } from "../../bookAppointments/actionTypes";

import { RebookingReasonModel } from "../../bookAppointments/models";

import { ActiveTaskAction } from "./ActiveTaskAction";

interface DispatchProps {
    rebook: (rebookingReasonModel: RebookingReasonModel) => void;
}

type AllProps = TaskActionProps & DispatchProps;

interface PropsFromDispatch {
    rebook: (task: TaskModel, rebookingReasonModel: RebookingReasonModel, preventNavigation?: boolean) => void;
}

const RebookButtonUnconnected: React.FunctionComponent<AllProps> = (props: AllProps) => {

    const [rebookingReason, setRebookingReason] = React.useState<string | undefined>(undefined);
    const [comments, setComments] = React.useState<string | undefined>(undefined);
    const [modalOpen, setModalOpen] = React.useState<boolean>(false);
    const [submitted, setSubmitted] = React.useState<boolean>(false);

    const onRebook = React.useCallback(() => setModalOpen(true), []);

    const onRebookCancel = React.useCallback(() => {
        setModalOpen(false);
        setRebookingReason(undefined);
        setComments(undefined);
    }, []);

    const onRebookConfirm = React.useCallback(() => {
        setSubmitted(true);
        if (!rebookingReason || !comments) {
            return;
        }

        setModalOpen(false);
        const rebookingReasonModel: RebookingReasonModel =
        {
            rebookingReason: rebookingReasonsOptions.find(o => o.value === rebookingReason)!.text,
            rebookingReasonComment: comments
        };

        props.rebook(rebookingReasonModel);

        if (props.delegate)
        {
            props.delegate(props.task.id);
        }
    }, [props, rebookingReason, comments]);

    return (
        <ActiveTaskAction task={props.task}>
            <Modal open={modalOpen}>
                <Modal.Header content="Appointment Move" />
                <Modal.Content>
                    <Form>
                        <Input.Dropdown
                            required
                            value={rebookingReason}
                            showErrors={submitted}
                            label="Reason"
                            options={rebookingReasonsOptions}
                            onChange={setRebookingReason}
                        />
                        <Divider hidden />
                        <Input.Textarea
                            required
                            value={comments}
                            showErrors={submitted}
                            label="Comments"
                            onChange={setComments}
                        />
                    </Form>
                </Modal.Content>
                <Modal.Actions>
                    <Button content="Cancel" onClick={onRebookCancel} />
                    <Button content="Rebook" onClick={onRebookConfirm} />
                </Modal.Actions>
            </Modal>
            <IsLoadingButton
                content="Rebook"
                floated="right"
                onClick={onRebook}
                requestNames={`${REBOOK_APPOINTMENT}_${props.task.id}`}
            />
        </ActiveTaskAction>
    );
};

const mapDispatchToProps = (dispatch: any) => ({
    rebook: (task: TaskModel, rebookingReasonModel: RebookingReasonModel, preventNavigation?: boolean) =>
        dispatch(rebookAppointment(task, rebookingReasonModel, preventNavigation))
});

const mergeProps = (stateProps: void, dispatchProps: PropsFromDispatch, ownProps: TaskActionProps): AllProps => ({
    ...ownProps,
    rebook: (rebookingReasonModel: RebookingReasonModel) => dispatchProps.rebook(ownProps.task, rebookingReasonModel, ownProps.preventNavigation),
});

export const RebookButton = connect(null, mapDispatchToProps, mergeProps)(RebookButtonUnconnected);
